import React, { useEffect, useState } from 'react';
import { Select, Table } from 'antd';
import { getLogsUserCodes, getLogsbyUsercode } from '../../utils/api';
import LoadingSpinner from '../loading-spinner/LoadingSpinner';


const { Option } = Select;

// eslint-disable-next-line no-empty-pattern
const Logs = ({ }) => {
    const [logs, setLogs] = useState([]);
    const [userCodes, setUserCodes] = useState([]);
    const [loading, setLoading] = useState(false);
    const [tableLoading, setTableLoading] = useState(false);

    const fetchData = async () => {
        const userCodes = await getLogsUserCodes();
        setUserCodes(userCodes)
    }
    useEffect(() => {
        setLoading(true);
        fetchData();
        setLoading(false)
    }, []);


    const columns = [
        {
            title: 'User Code',
            dataIndex: 'user_code',
            key: 'id',
        },
        {
            title: 'Connection ID',
            dataIndex: 'connection_id',
            key: 'id',
        },
        {
            title: 'Connected At',
            dataIndex: 'connected_at',
            key: 'id',
        },
        {
            title: 'Disconnected At',
            dataIndex: 'disconnected_at',
            key: 'id',
        },
        {
            title: 'Close Message',
            dataIndex: 'close_message',
            key: 'id',
        },
        {
            title: 'Close Reason',
            dataIndex: 'close_reason',
            key: 'id',
        },
    ];

    const [selectedOption, setSelectedOption] = useState('');

    const handleOptionChange = async (value) => {
        if(value.length > 0) {
            setTableLoading(true);
            setSelectedOption(value);
            const logs = await getLogsbyUsercode(value);
            setLogs(logs);
            setTableLoading(false);
        } else {
            setSelectedOption(value);
            setLogs([]);
        }
    };

    return (
        <div className="User">
            {loading && <LoadingSpinner />}

            <div style={{marginBottom: '1rem'}}>
                <Select
                    value={selectedOption}
                    onChange={handleOptionChange}
                    style={{ width: 220 }}
                >
                    <Option value="">Select usercode to get logs</Option>
                    {userCodes.map((code) => (
                        <Option key={code.user_code} value={code.user_code}>
                            {code.user_code}
                        </Option>
                    ))}
                </Select>
            </div>
            {!loading &&
                <Table
                    dataSource={logs}
                    columns={columns}
                    loading={tableLoading}
                />}

        </div>)
        ;
};

export default Logs;
